module.exports = __webpack_public_path__ + "static/media/welcome.3f638887.jpeg";